import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7ff6512c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "rounded-4 bg-white shadow px-5 py-4" }
const _hoisted_2 = { class: "fw-bold mb-4" }

import { useRoute } from 'vue-router'
import { translate } from '@/languages/i18n'
import Alumnus from './components/Alumnus.vue'
import Tabs, { Tab } from '@/components/tabs/index.vue'
import Breadcrumb from '@/components/breadcrumb/index.vue'
import TabPanel from '@/components/tabs/panel/TabPanel.vue'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const route = useRoute()

const breadcrumb = [
  {
    content: translate('CC10home'),
    to: `/community/communities/${route.params?.id}/dashboard`,
    active: false,
  },
  {
    content: translate('settings'),
    to: '',
    active: false,
  },
  {
    content: translate('CD40precautions'),
    to: '',
    active: true,
  },
]

const tabs: Array<Tab> = [
  {
    title: translate('CD40alumnusUser'),
    alias: 'alumni',
  },
  {
    title: translate('CD40enrolledUser'),
    alias: 'employee',
  },
]

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(Breadcrumb, { breadcrumb: breadcrumb }),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("h5", _hoisted_2, _toDisplayString(_unref(translate)('CD40precautions')), 1),
      _createElementVNode("div", null, [
        _createVNode(Tabs, {
          tabs: tabs,
          "default-alias": 'alumni'
        }, {
          default: _withCtx(() => [
            _createVNode(TabPanel, {
              alias: 'alumni',
              keyName: 1
            }, {
              default: _withCtx(() => [
                _createVNode(Alumnus)
              ]),
              _: 1
            }),
            _createVNode(TabPanel, {
              alias: 'employee',
              keyName: 2
            }, {
              default: _withCtx(() => [
                _createVNode(Alumnus)
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ])
    ])
  ], 64))
}
}

})